import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import GymMenu from "../GymMenu";

import ActiveUsers from "./ActiveUsers";
import Amenities from "./Amenities";
import Reviews from "./Reviews";
import Facilities from "./Facilities";
import Payments from "./Payments";
import Trainers from "./Trainers";
import Notes from "./Notes";
import axios from "axios";
import { toast } from "react-toastify";
import { API_URL, ERROR_HANDLE } from "config/constants";
import GalleryModal from "../Modals/GalleryModal";

class SingleGym extends React.Component {
  state = {
    gym_id: 0,
    gym: {},
    cover_images: [],
    showGallery: false,
    currentGalleryIndex: 0
  };
  gym = id => {
    const toastId = toast("Fetching Gym Data...");
    const access_token = localStorage.getItem("access_token");
    axios
      .get(`${API_URL}/admin/gyms/${id}`, {
        headers: {
          "x-access-token": access_token
        }
      })
      .then(res => {
        toast.dismiss(toastId);
        this.setState({
          ...this.state,
          gym: res.data[0],
          cover_images: res.data[0].cover_images
        });
      })
      .catch(err => {
        ERROR_HANDLE(err);
      });
  };

  componentWillMount() {
    const gym_id = localStorage.getItem("currentGymID");
    this.gym(gym_id);
  }

  componentDidMount() {
    const gym_id = localStorage.getItem("currentGymID");
    this.setState({
      ...this.state,
      gym_id: gym_id
    });
  }
  showGallery = () => {
    const {gym} = this.state;
    if (gym.cover_images && gym.cover_images.length > 0) {
      this.setState({
        ...this.state,
        showGallery: true,
        currentGalleryImage: this.state.gym.cover_images[
          this.state.currentGalleryIndex
        ]
      });
    }
  };
  closeGallery = () => {
    this.setState({
      ...this.state,
      showGallery: false
    });
  };
  nextImage = () => {
    if (this.state.gym.cover_images[this.state.currentGalleryIndex + 1]) {
      this.setState({
        ...this.state,
        currentGalleryIndex: this.state.currentGalleryIndex + 1,
        currentGalleryImage: this.state.gym.cover_images[
          this.state.currentGalleryIndex + 1
        ]
      });
    } else {
      this.closeGallery();
    }
  };

  previousImage = () => {
    if (this.state.gym.cover_images[this.state.currentGalleryIndex - 1]) {
      this.setState({
        ...this.state,
        currentGalleryIndex: this.state.currentGalleryIndex - 1,
        currentGalleryImage: this.state.gym.cover_images[
          this.state.currentGalleryIndex - 1
        ]
      });
      // this.showGallery();
    }
  };

  deleteImage = () => {
    const access_token = localStorage.getItem("access_token");
    const { gym_id, currentGalleryImage } = this.state;
    if (currentGalleryImage) {
      const toastId = toast("Delete Cover Image...");
      const x = currentGalleryImage.split("/");

      axios
        .delete(
          `${API_URL}/admin/gyms/profile/cover/image?gym_id=${gym_id}&name=${
          x[x.length - 1]
          }`,
          {
            headers: {
              "x-access-token": access_token
            }
          }
        )
        .then(res => {
          toast.dismiss(toastId);
          this.gym(gym_id);
          window.location.reload();
        })
        .catch(err => {
          ERROR_HANDLE(err);
        });
    }
    
  };

  render() {
    const {
      gym_name,
      profile_picture,
      email,
      phone,
      rating,
      address,
      working_hours,
      working_hours_full,
      reviews,
      cover_images,
      active_users,
      gym_id,
      rate,
      is_available,
      is_test_enabled,
      payment,
      qr_code,
      total_amount,
      flexit_amount,
      time_note,
      gym_note,
      is_trainer_enabled,
      personal_trainer_rate,
      trainers
    } = this.state.gym;

    return (
      <div>
        {this.state.showGallery ? (
          <GalleryModal
            prev={this.previousImage}
            next={this.nextImage}
            image={
              this.state.currentGalleryImage
                ? this.state.currentGalleryImage
                : ""
            }
            close={this.closeGallery}
            deleteFn={this.deleteImage}
          />
        ) : (
            ""
          )}
        <GymMenu
          gym={this.state.gym}
          gymid={gym_id}
          name={gym_name}
          pic={profile_picture}
          rating={parseInt(rating, 10)}
          city={String(address).split(",")[1]}
          images={cover_images}
          test={is_test_enabled}
          available={is_available}
          qr={qr_code}
          galleryTrigger={this.showGallery}
        />
        {/* <GymNavigation /> */}
        <Router>
          <Switch>
            <Route
              exact={true}
              path="/gyms/gym/"
              render={props => <ActiveUsers {...props} users={active_users} />}
            />
            <Route
              path="/gyms/gym/activeusers/"
              render={props => <ActiveUsers {...props} users={active_users} />}
            />
            {/* <Route path="/gyms/gym/reviews/" component={Reviews} /> */}
            <Route
              path="/gyms/gym/reviews/"
              render={props => <Reviews {...props} reviews={reviews} />}
            />
            <Route
              path="/gyms/gym/amenities/"
              render={props => <Amenities {...props} gymid={gym_id} />}
            />
            <Route
              path="/gyms/gym/facilities/"
              render={props => (
                <Facilities
                  {...props}
                  gym={this.state.gym}
                  email={email}
                  address={address}
                  phone={phone}
                  hours={working_hours}
                  workinghours={working_hours_full}
                  rate={rate}
                  gymid={gym_id}
                  time_note={time_note}
                  updateGym={this.gym}
                />
              )}
            />
            <Route
              path="/gyms/gym/payments/"
              render={props => (
                <Payments
                  {...props}
                  amount={payment}
                  flexitRevenue={flexit_amount}
                  totalRevenue={total_amount}
                  gym_id={gym_id}
                />
              )}
            />
             <Route
              path="/gyms/gym/trainers/"
              render={props => <Trainers {...props} gym={this.state.gym} trainers={trainers} />}
            />
            <Route
              path="/gyms/gym/notes/"
              render={props => (
                <Notes {...props} gym_id={gym_id} gym_note={gym_note} />
              )}
            />
          </Switch>
        </Router>
      </div>
    );
  }
}

export default SingleGym;
